<template>
  <div class="ml-5">
    <v-btn
      :block="setBlock"
      :bottom="setBottom"
      :color="setColor"
      :depressed="setDepressed"
      :disabled="setDisable"
      :elevation="setElevation"
      :fab="setFab"
      :icon="setIcon"
      :loading="setLoading"
      :outlined="setOutline"
      :plain="setPlain"
      :small="setSmall"
      :rounded="setRound"
      :x-small="setXSmall"
      @click="emitFunction"
    >
      <slot>Click Me!</slot>
    </v-btn>
  </div>
</template>
<script setup>
  import check from "@/../../library/helper/propertyCheck.js";
  import { ref, watch } from "vue";

  const props = defineProps({ config: { type: Object, required: false } });
  const emit = defineEmits(["button-event"]);

  // Property check method
  const propCheck = (key, value) =>
    check.checkSetting(props.config, key, value);

  let setBlock = ref(propCheck("block", false));
  let setBottom = ref(propCheck("bottom", false));
  let setColor = ref(propCheck("color", undefined));
  let setDepressed = ref(propCheck("depressed", false));
  let setDisable = ref(propCheck("disable", false));
  let setElevation = ref(propCheck("elevation", undefined));
  let setFab = ref(propCheck("fab", false));
  let setIcon = ref(propCheck("icon", false));
  let setLoading = ref(propCheck("loading", false));
  let setOutline = ref(propCheck("outline", false));
  let setPlain = ref(propCheck("plain", false));
  let setSmall = ref(propCheck("small", false));
  let setRound = ref(propCheck("round", false));
  let setXSmall = ref(propCheck("xsmall", false));

  const runSetup = () => {
    console.log("^^^^^^^^^ Running BUTTON Setup")
    setBlock.value = propCheck("block", false);
    setBottom.value = propCheck("bottom", false);
    setColor.value = propCheck("color", undefined);
    setDepressed.value = propCheck("depressed", false);
    setDisable.value = propCheck("disable", false);
    setElevation.value = propCheck("elevation", undefined);
    setFab.value = propCheck("fab", false);
    setIcon.value = propCheck("icon", false);
    setLoading.value = propCheck("loading", false);
    setOutline.value = propCheck("outline", false);
    setPlain.value = propCheck("plain", false);
    setSmall.value = propCheck("small", false);
    setRound.value = propCheck("round", false);
    setXSmall.value = propCheck("xsmall", false);
    console.log(`Disable Status = `, setDisable.value)
  };

  watch(props, () => runSetup());
  // Emit the button click
  const emitFunction = () => {
    emit("button-event");
  };
</script>
